/**
 * /frontend/src/features/analytics/components/offers/TopOffersChart.js
 */

import React from 'react';
import ChartContainer from '../shared/ChartContainer';
import HorizontalBarChart from '../charts/HorizontalBarChart';
import { CHART_COLORS } from '../../constants/chartColors';

/**
 * Top offers chart by redemptions.
 * @param {{data:Array<{label:string,redeemed:number}>}} props
 * @returns {JSX.Element}
 */
const TopOffersChart = ({ data }) => (
  <ChartContainer title="Top Offers" subtitle="Top 10 by redemption count">
    <HorizontalBarChart data={data} xKey="label" yKey="redeemed" color={CHART_COLORS.success} />
  </ChartContainer>
);

export default TopOffersChart;
